import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Motion, spring } from 'react-motion';

import imgCircle from './img/circle.svg';

import { withTranslation } from 'react-i18next'

const expectedResult = [20, 15, 7.5, 2];

class Results extends Component {

  render(){
    return(
      <div className="graphics">
        <h5 tabIndex={0}>{this.props.t("Predicted Results ")}</h5>
        <p tabIndex={0}>{this.props.t("These are your initial predictions.")}</p>
        <ul>
          {this.props.solutions.map((solution, index)=>(
            <li className="dropTarget"
                key={index} tabIndex={0} aria-label={this.props.t('Blotting paper, position'+solution.id)+', '+solution.prediction+' '+this.props.t('microliters.')}>
              <div className="indicator">
                <img
                  className={"prediction"+solution.id}
                  style={{ pointerEvents: "none", width: ((solution.prediction / solution.maxVol) * 100)+"%" }}
                  src={imgCircle}
                  alt={
                    this.props.t(
                      "Blotting Paper position {{solution}}, covering {{percentage}}% surface area",
                      {
                        solution: solution.id,
                        percentage: Math.round((solution.prediction / solution.maxVol) * 100)
                      }

                    )
                  }
                />
              </div>
              <p className="zone-label volume"><span className="zone-label index">{solution.id}</span> | {solution.prediction}{this.props.t("μl")}</p>
            </li>
          ))}
        </ul>
        <h5 tabIndex={0}>{this.props.t("Actual Results")}</h5>
        <p tabIndex={0}>{this.props.t("These are your results based on the volumes you pipetted.")}</p>
        <ul>
          {this.props.solutions.map((solution, index)=>(
            <li className='dropTarget'
                key={index} tabIndex={0} aria-label={this.props.t('Blotting paper, position'+solution.id) + ', ' + solution.volume + " " + this.props.t('microliters.') + ( ( (Math.round(solution.volume * 10) / 10 ) === expectedResult[index] ) ? this.props.t("correct") : this.props.t("incorrect") ) }>
              <div className="indicator">
                <img
                  className={"result"+solution.id}
                  style={{ pointerEvents: "none", width: ((solution.volume / solution.maxVol) * 100)+'%' }}
                  src={imgCircle}
                  alt={
                    this.props.t(
                      "Blotting Paper position {{solution}}, covering {{percentage}}% surface area",
                      {
                        solution: solution.id,
                        percentage: Math.round((solution.volume / solution.maxVol) * 100)
                      }
                    )
                  }
                />
              </div>
              <p className='zone-label volume'><span className="zone-label index">{solution.id}</span> | {this.props.t(Math.round( solution.volume * 10 ) / 10 + "μl")}</p>
              <p className={((Math.round(solution.volume * 10) / 10) === expectedResult[index])?"Correct":"Incorrect"}>
                {((Math.round(solution.volume * 10) / 10) === expectedResult[index])?this.props.t("Correct!"):this.props.t("Incorrect!")}
              </p>
            </li>
          ))}
        </ul>
        <h5 tabIndex={0}>{this.props.t("Ideal Results")}</h5>
        <p tabIndex={0}>{this.props.t("These are the sizes you would expect to see if you pipetted the correct volumes.")}</p>
        <ul>
          {this.props.solutions.map((solution, index)=>(
            <li className='dropTarget'
                key={index} tabIndex={0} aria-label={this.props.t('Blotting paper, position'+solution.id) + ', '+expectedResult[index]+" "+this.props.t('microliters.')}>
              <div className="indicator">
                <img
                  className={"expected-result"+solution.id}
                  style={{ pointerEvents: "none", width: ((expectedResult[index] / solution.maxVol) * 100)+'%' }}
                  src={imgCircle}
                  alt={
                    this.props.t(
                      "Blotting Paper position {{solution}}, covering {{percentage}}% surface area",
                      {
                        solution: solution.id,
                        percentage: Math.round((expectedResult[index] / solution.maxVol) * 100)
                      }
                    )
                  }
                />
              </div>
              <p className='zone-label volume'><span className="zone-label index">{solution.id}</span> | {expectedResult[index]}{this.props.t("μl")}</p>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        id: ownProps.id,
        solutions: state.blotPaper.blotPapers[ownProps.id-1].solutions
    };
};

export default connect(mapStateToProps)(withTranslation()(Results));
